import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import AOS from 'aos';
import { CommonModule } from '@angular/common';
import { LoaderService } from './shared/services/loader.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule, ProgressSpinnerModule, ToastModule],
  providers: [MessageService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  loading$: Observable<boolean>;
  title = 'buy2_website';
  private routerSubscription?: Subscription;

  constructor(private router: Router, private _loaderService: LoaderService) {
    this.loading$ = this._loaderService.isLoading$;
  }

  ngOnInit() {
    // Initialize AOS (Animate On Scroll)
    AOS.init({
      duration: 1000, // Animation duration
      easing: 'ease-in-out', // Easing function
      once: true, // Animation happens only once
      mirror: false, // Don't animate out while scrolling past them
      offset: 120, // Offset (in px) from the original trigger point
      delay: 0, // Delay on animations
      anchorPlacement: 'top-bottom', // When to trigger animations
      // disable: false, // Never disable animations
      // startEvent: 'DOMContentLoaded', // Start event
    });

    // Initial refresh after page load
    setTimeout(() => {
      AOS.refresh();
    }, 500);

    // Refresh AOS on route change
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Scroll to top on route change (skip when navigating to a fragment anchor)
        if (!event.urlAfterRedirects.includes('#')) {
          window.scrollTo(0, 0);
        }
        // Small delay to ensure DOM is ready
        setTimeout(() => {
          AOS.refresh();
        }, 300);
      });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
